import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import LineChart from "../../components/common/Charts/LineChart";
import OnBoardTable from "../../components/OnboardTable/OnBoardTable";

import { applicantProfileService } from "../../services";
import styles from "./Dashboard.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { ApplicantActions } from "../../actions";
import { Card, CardBody, CardFooter, CardTitle } from "reactstrap";
import Loader from "../../components/common/Loader/Loader";
import moment from "moment";
import WelcomePage from "../../components/common/noDatafound/welcomePage";
function Dashboard() {
  const [pending, setPending] = useState(false);
  const [onBoardData, setOnBoardData] = useState(null);
  const [sort, setSort] = useState("id");
  const [sortType, setSortType] = useState("desc");
  const [page, setPage] = useState(1);
  const [customFilter, setCustomFilter] = useState(null);
  const [selectedChartFilter, setSelectedChartFilter] = useState("1Y");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const profileSummary = useSelector((state) => state.applicant.profileSummary);
  const chartSummary = useSelector((state) => state.applicant.chartSummary);
  const user = useSelector((state) => state.authentication.user);

  useEffect(() => {
    // if (user && user?.userRole === 4) {
    //   navigate("/applicants");
    // }
    navigate("/applicants");
  }, [user]);
  useEffect(() => {
    getOnBoardApplicationData();
  }, [page, sort, sortType]);

  useEffect(() => {
    setLoading(true);
    dispatch(ApplicantActions.getProfileSummary());
    dispatch(ApplicantActions.getChartSummary());
  }, []);

  const getRequestParams = (page, pageSize, sort, sortType) => {
    let params = {};
    if (page) {
      params["page"] = page;
    }

    if (sort) {
      params["sort"] = sort;
    }

    if (sortType) {
      params["sort_type"] = sortType;
    }

    if (pageSize) {
      params["page_size"] = pageSize;
    }
    params["applicationStatus"] = "On Board";
    return params;
  };

  const columns = [
    {
      name: "Applicant Name",
      selector: (row) => row?.name,
      sortable: true,
      sortField: "name",
      style: {
        paddingLeft: "10px",
      },
    },
    {
      name: "Job Profile",
      selector: (row) => row?.job_profile?.name,
      sortable: true,
      sortField: "noOfProfiles",
    },
    {
      name: "Cluster",
      selector: (row) => row?.cluster,
      sortable: true,
      sortField: "cluster",
    },
    {
      name: "Joining Date",
      selector: (row) =>
        row?.date_of_joinig
          ? moment(row?.date_of_joinig).format("DD-MM-YYYY")
          : "",
      sortable: true,
      sortField: "date_of_joinig",
    },
  ];

  const handleSort = async (column, sortDirection) => {
    if (column?.sortField) {
      setSort(column?.sortField);
      setSortType(sortDirection);
    }
  };

  const getOnBoardApplicationData = async () => {
    let query = await getRequestParams(1, 10, sort, sortType);
    applicantProfileService
      .getAllApplicant(query)
      .then((res) => {
        setOnBoardData(res);
        if (res?.results.length > 0) {
          res.results[0].defaultExpanded = true;
        }
        setPending(false);
        setLoading(false);
      })
      .catch((e) => {
        setOnBoardData({});
        setPending(false);
        setLoading(false);
      });
  };
  const renderChartData = (parm, monthVal) => {
    if (parm !== selectedChartFilter) {
      setSelectedChartFilter(parm);
      setCustomFilter(null);
      if (monthVal) {
        let query = `month=${monthVal}`;
        dispatch(ApplicantActions.getChartSummary(query));
      }
    }
  };
  const handleCustomFilterOption = (customFilter) => {
    setCustomFilter(customFilter);
    if (customFilter?.startDate && customFilter?.endDate) {
      let query = `start_date=${customFilter?.startDate}&end_date=${customFilter?.endDate}`;
      dispatch(ApplicantActions.getChartSummary(query));
      setSelectedChartFilter("custom");
    }
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return loading ? (
    <Loader color={"#5382ba"} />
  ) : profileSummary && profileSummary.length > 0 ? (
    <div className={styles.DashboardMain}>
      <div className={styles.sliderPart}>
        {profileSummary && (
          <Carousel responsive={responsive}>
            {profileSummary?.map((val, index) => {
              return (
                <Card
                  className={styles.mainCard}
                  onClick={() => {
                    navigate(`/openings?jobProfile=${val?.id}`);
                  }}
                >
                  <CardTitle className={`${styles.mainCardTitle} py-3 ps-4`}>
                    {val.name}
                  </CardTitle>
                  <CardBody className={styles.mainCardBody}>
                    <div className="container">
                      <div className="row mb-3 mt-3">
                        <div className={`${styles.columnText} col p-0`}>
                          <p>Openings</p>
                          <p className={`${styles.opText}`}>
                            {" "}
                            {val?.totalOpening}
                          </p>
                        </div>
                        <div className={`${styles.columnText} col p-0`}>
                          <p>Processing</p>
                          <p className={`${styles.opText}`}>
                            {val?.processingApplicants}
                          </p>
                        </div>
                      </div>
                      <div className="row">
                        <div className={`${styles.columnText} col p-0`}>
                          <p>Selected</p>
                          <p className={`${styles.onboardText}`}>
                            {" "}
                            {val?.placedApplicants}
                          </p>
                        </div>
                        <div className={`${styles.columnText} col p-0`}>
                          <p>On Board</p>
                          <p className={`${styles.onboardText}`}>
                            {" "}
                            {val?.onBoard ? val?.onBoard : 0}
                          </p>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                  <CardFooter className={styles.mainCardFooter}>
                    <span className="text-success">
                      <strong>{val?.percentage ? val?.percentage : 0} %</strong>
                    </span>{" "}
                    Complete
                  </CardFooter>
                </Card>
              );
            })}
          </Carousel>
        )}
      </div>
      <div className={styles.chartMainPart}>
        {chartSummary != null &&
        chartSummary?.labels &&
        chartSummary?.dataset.length > 0 ? (
          <LineChart
            title="Analytics"
            labels={chartSummary?.labels}
            yTitle="Number of Applicant"
            datasets={chartSummary?.dataset}
            selectedChartFilter={selectedChartFilter}
            setSelectedChartFilter={setSelectedChartFilter}
            renderChartData={renderChartData}
            handleCustomFilterOption={handleCustomFilterOption}
            customFilter={customFilter}
          />
        ) : (
          ""
        )}
      </div>
      <div className={styles.onBoardPart}>
        <div className={styles.onBoardHeading}>
          <span className={styles.onBardText}>On Board</span>
          <span
            className={styles.viewAll}
            onClick={() => navigate("/applicants?applicationStatus=On Board")}
          >
            View All
          </span>
        </div>
        <div className="onBordTable">
          <OnBoardTable
            pending={pending}
            onBoardData={onBoardData}
            columns={columns}
            handleSort={handleSort}
          />
        </div>
      </div>
    </div>
  ) : (
    <WelcomePage />
  );
}

export default Dashboard;
